import { render, staticRenderFns } from "./TariffEdit.vue?vue&type=template&id=66b22503&scoped=true&lang=pug"
import script from "./TariffEdit.vue?vue&type=script&lang=js"
export * from "./TariffEdit.vue?vue&type=script&lang=js"
import style0 from "./TariffEdit.vue?vue&type=style&index=0&id=66b22503&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b22503",
  null
  
)

export default component.exports